/**
 * As categorias de projeto — as que o banco tem, não as que se imaginava.
 *
 * Conferido no banco em 28/09/2026: Linha leve (608), Suporte (233) e Linha
 * pesada (80). São as três do `<select>` do cadastro antigo. As telas novas
 * tinham cada uma a sua lista ("Motos", "Motocicleta", "Agrícola"), nenhuma com
 * "Suporte": o filtro por categoria não achava 233 projetos.
 */
export const CATEGORIAS = ["Linha leve", "Linha pesada", "Suporte"] as const
